import { Instagram, Facebook, Youtube, Linkedin, Twitter, Globe, MessageCircle, Music2, Ghost, Pin } from 'lucide-react'
import { t } from '../i18n'

// Social networks a store can link to. The server only saves http(s) URLs
// (and digits for WhatsApp), so hrefs built here are always safe.
export const SOCIAL_NETWORKS = [
  { key: 'instagram', label: 'Instagram', icon: Instagram, placeholder: 'instagram.com/yourstore' },
  { key: 'facebook', label: 'Facebook', icon: Facebook, placeholder: 'facebook.com/yourstore' },
  { key: 'tiktok', label: 'TikTok', icon: Music2, placeholder: 'tiktok.com/@yourstore' },
  { key: 'x', label: 'X (Twitter)', icon: Twitter, placeholder: 'x.com/yourstore' },
  { key: 'youtube', label: 'YouTube', icon: Youtube, placeholder: 'youtube.com/@yourstore' },
  { key: 'linkedin', label: 'LinkedIn', icon: Linkedin, placeholder: 'linkedin.com/company/yourstore' },
  { key: 'snapchat', label: 'Snapchat', icon: Ghost, placeholder: 'snapchat.com/add/yourstore' },
  { key: 'pinterest', label: 'Pinterest', icon: Pin, placeholder: 'pinterest.com/yourstore' },
  { key: 'whatsapp', label: 'WhatsApp', icon: MessageCircle, placeholder: '+968 9000 0000' },
  { key: 'website', label: 'Website', icon: Globe, placeholder: 'www.yourstore.com' },
]

const hrefFor = (key, value) => key === 'whatsapp' ? `https://wa.me/${String(value).replace(/\D/g, '')}` : value

// Row of icon links for the storefront header/footer. Renders nothing when
// the store hasn't added any.
export default function SocialLinks({ links, className = '', size = 18 }) {
  const active = SOCIAL_NETWORKS.filter(n => links?.[n.key])
  if (!active.length) return null
  return (
    <ul className={`social-links ${className}`} aria-label={t("Follow us")}>
      {active.map(({ key, label, icon: Icon }) => (
        <li key={key}>
          <a href={hrefFor(key, links[key])} target="_blank" rel="noopener noreferrer" aria-label={label} title={label}>
            <Icon size={size} aria-hidden="true" />
          </a>
        </li>
      ))}
    </ul>
  )
}
